import { FC } from 'react';

interface IHeading {
  title: string;
}

const Heading: FC<IHeading> = ({ title }) => {
  return (
    <div className="bg-[var(--mantine-primary-color-filled)] p-8 text-white shadow-[inset_0px_-7px_6px_#3e4f5c] relative z-[1]">
      <div className="container">
        <h3 className="text-[35px]">{title}</h3>
      </div>
    </div>
  );
};

export default Heading;
